import React, { Fragment, useEffect, useMemo, useState } from "react";
import { Row, Col, Button, Container } from "react-bootstrap";
import classes from "../WebsiteManagement/websiteManagement.module.css";
import Page from "../pagination/pagination";
import {
  GetAdminBusBookings,
  DownloadBookingTicket,
  DownloadBookingInvoice,
} from "../../entities/action/action";

const PAGE_SIZE = 50;
const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const getBusCustomerName = (item) => {
  const lead = (item.passengers || []).find((p) => p.lead) || item.passengers?.[0];
  if (!lead) return item.name || "-";
  return `${lead.firstName || ""} ${lead.lastName || ""}`.trim() || item.name || "-";
};

const BusBookingCard = ({ item }) => {
  const orderDate = new Date(item?.orderDate);
  const travelDate = new Date(item?.journeyDate);
  const customerName = getBusCustomerName(item);

  return (
    <Row
      style={{
        backgroundColor: "#f9f9f9",
        padding: "15px 25px",
        alignItems: "center",
        boxShadow: "-1px 2px 8px #ddd",
        margin: "15px 0",
      }}
    >
      <Col md={2}>
        <div style={{ color: "#adb0b8" }}>{travelDate.getDate()}</div>
        <div>{month[travelDate.getMonth()]}</div>
        <div style={{ color: "#ef3f3e" }}>{travelDate.getFullYear()}</div>
      </Col>
      <Col md={2}>🚌</Col>
      <Col md={3}>
        <div>
          {item.sourceCity} → {item.destinationCity}
        </div>
        <div style={{ color: "gray" }}>{item.name || customerName}</div>
        <div style={{ color: "gray" }}>{item.phone || "-"}</div>
        <div style={{ color: "gray" }}>{item.operatorName || "Bus"}</div>
        <div style={{ color: "gray" }}>
          {(item.passengers || [])
            .filter((p) => p.seatName)
            .map((p) => p.seatName)
            .join(", ")}
        </div>
        <div style={{ color: "gray" }}>INR {Number(item.amount) / 100}</div>
      </Col>
      <Col md={3}>
        <p>Ref: {item.bookingRef}</p>
        <div style={{ color: "gray" }}>
          {orderDate.getDate()}/{month[orderDate.getMonth()]}/{orderDate.getFullYear()}
        </div>
      </Col>
      <Col md={2}>
        <Button size="sm" variant="outline-primary" style={{ fontSize: 10, marginBottom: 5 }} onClick={() => DownloadBookingTicket(item.bookingId)}>
          Download ticket
        </Button>
        <Button
          size="sm"
          variant="outline-secondary"
          style={{ fontSize: 10 }}
          onClick={() => DownloadBookingInvoice(item.bookingId, `Bus_Invoice_${item.bookingRef || item.bookingId}.pdf`)}
        >
          Download invoice
        </Button>
        <div style={{ background: "#0dcaf0", padding: 5, marginTop: 5, textAlign: "center" }}>
          {(item?.status || "").toUpperCase()}
        </div>
      </Col>
    </Row>
  );
};

const BusBookings = () => {
  const [all, setAll] = useState([]);
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [page, setPage] = useState(1);

  useEffect(() => {
    (async () => {
      const res = await GetAdminBusBookings();
      if (res.success && res.bookings) setAll(res.bookings);
    })();
  }, []);

  useEffect(() => {
    setPage(1);
  }, [search]);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return all;
    return all.filter((b) => {
      const name = (b.name || getBusCustomerName(b)).toLowerCase();
      const phone = String(b.phone || "").toLowerCase();
      return name.includes(q) || phone.includes(q);
    });
  }, [all, search]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const pageItems = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <Fragment>
      <Container style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
        <form
          onSubmit={(e) => e.preventDefault()}
          style={{ display: "flex", alignItems: "stretch", width: "50vw" }}
        >
          <input
            className={classes.SearchInput}
            placeholder="Search by Name or Phone Number"
            value={searchInput}
            onChange={(e) => {
              setSearchInput(e.target.value);
              setSearch(e.target.value);
            }}
          />
          <button type="button" className={classes.SearchButton} onClick={() => setSearch(searchInput)}>
            Search
          </button>
        </form>
      </Container>
      {pageItems.length ? pageItems.map((item) => <BusBookingCard key={item.bookingId} item={item} />) : <p>No bus bookings found</p>}
      {totalPages > 1 && <Page count={totalPages} page={page} change={(_, v) => setPage(v)} />}
    </Fragment>
  );
};

export default BusBookings;
